import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { Document, GenerateDocument } from './document.interface';
import { EmployeeDocumentService } from './document.service';
const service = new EmployeeDocumentService();

export interface EmployeeDocumentState {
   documentsOverview?: PaginatedResponse<Document>;
}

const state: EmployeeDocumentState = {};

const getters = {
   employeeDocumentsOverview(state: EmployeeDocumentState) {
      return state.documentsOverview;
   },
};

const mutations = {
   SET_EMPLOYEE_DOCUMENTS_OVERVIEW(state: EmployeeDocumentState, overview: PaginatedResponse<Document>) {
      state.documentsOverview = overview;
   },
};

const actions = {
   async getEmployeeDocuments(context: any, payload: { employeeId: number; query: any }) {
      return await service.getEmployeeDocuments(payload.employeeId, payload.query).then((response) => {
         context.commit('SET_EMPLOYEE_DOCUMENTS_OVERVIEW', response);
         return response;
      });
   },
   async generateEmployeeDocument(context: any, payload: { employeeId: number; generateDocument: GenerateDocument }) {
      return await service.generateEmployeeDocument(payload.employeeId, payload.generateDocument);
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
